// Single source of truth for the SMS opt-in consent language (spec: contact-phone-consent
// AC-2.2). The rendered checkbox label, the persisted ConsentAudit version, and the A2P
// registration evidence bundle all reference THIS text and version. Any edit to the copy
// MUST bump the version string (consent-v1 -> consent-v2) — the server env
// SMS_CONSENT_TEXT_VERSION is the authoritative persisted value and must be kept in step.
//
// BEFORE YOU EDIT THE TEXT BELOW, read evanhowell-nrk5. This file is imported by BOTH the Lambda
// and the browser bundle, and the two deploy as separate artifacts. The path classifier used to
// send a shared-file change to the backend only, which would have left the old sentence on the
// page while the Lambda stamped the new version — a consent record naming text nobody was shown.
// That classifier is fixed (deploy.yml, src/shared/ is now a frontend path too) and history shows
// it never fired, because this file has only ever been edited alongside src/web/ changes.
//
// The stronger guard is NOT here: the leasing disclosure has the browser echo its bundled version
// so the server can resolve it against an approved set (src/shared/leasingDisclosure.ts,
// src/interview/inviteOrder.ts). The contact path deliberately does not, because the classifier fix
// removed the cause and this text has changed once in the project's life. YOUR EDIT IS THAT SECOND
// TIME. Give this path the same approved-version map as part of the change, and the mismatch
// warning at src/contact/handler.ts:190-199 stops being the only thing watching.

export const SMS_CONSENT_TEXT_VERSION = "consent-v1";

// Plain-text sentence; the trailing policy references are rendered as links by the form
// bootstrap (contactMain) using PRIVACY_PATH/TERMS_PATH below.
export const SMS_CONSENT_TEXT =
  "I agree to receive text messages from Evan Howell Properties about my inquiry and " +
  "scheduling my interview (up to 4 msgs/month). Msg & data rates may apply. Reply STOP " +
  "to opt out, HELP for help. Consent is not a condition of service. See our " +
  "Privacy Policy and Terms.";

export const PRIVACY_PATH = "/privacy.html";
export const TERMS_PATH = "/terms.html";
